import Logo from "@/assets/icons/Logo";
import { Button } from "@/components/shared/Button/Button";
import { LanguageDropdown } from "@/components/ui/language-dropdown";
import { useChangeLanguage } from "@/hooks/useChangeLanguage";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

interface HeaderProps {
  route: string;
  isLoading?: boolean;
  text: string;
  onLogout?: false | (() => void);
  hideButton?: boolean;
}

export default function Header({
  route,
  isLoading,
  text,
  onLogout = false,
  hideButton,
}: HeaderProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (onLogout) {
      onLogout();
      navigate("/login", { state: { from: location.state?.from, inviteEmail: location.state?.inviteEmail, inviteToken: location.state?.inviteToken } });
    } else if (route) {
      navigate(route, { state: { from: location.state?.from, inviteEmail: location.state?.inviteEmail, inviteToken: location.state?.inviteToken } });
    }
  };

  const { i18n } = useTranslation();
  const handleChangeLanguage = useChangeLanguage();

  return (
    <header className="flex w-full h-16 justify-between px-4 md:px-10 items-center">
      <Logo />

      <div className="flex items-center gap-2">
        <LanguageDropdown
          defaultValue={i18n.language || "pt"}
          onChange={handleChangeLanguage}
          slim
        />
        {!hideButton && (
          <Button
            disabled={isLoading}
            onClick={handleClick}
            variant="link"
            className="w-32 h-5"
          >
            {text}
          </Button>
        )}
      </div>
    </header>
  );
}
